import {
  availableReportTypes,
  availableUpdateReportTypes,
} from 'constants/report';

import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';

import ClientOptionsSuperAdmin from './ClientOptionsSuperAdmin';
import WorkspaceOptionsSuperAdmin from './WorkspaceOptionsSuperAdmin';
import FieldTextInput from '../../../components/FieldTextInput';
import FormInput from '../../../components/FormInput';
import FormInputSelect from '../../../components/FormInputSelect';
import { MARKET_SURVEY } from '../../../constants/report';
import { PageHeader } from '../../../styles/themeComponents';
import styles from '../RequestReport.module.css';

interface Props {
  change: (field: string, value: any) => void;
  inUpdateReportMode?: boolean;
  reportType?: SelectItem | null;
  isCloning?: boolean;
}

const required = (value) => (value ? undefined : 'Required');
const validateFirstCharacter = (value) =>
  value.length && !/^[a-zA-Z0-9]+$/.test(value[0])
    ? 'First letter can only be alphanumeric'
    : undefined;
const validateNameLength = (value) =>
  value.length > 128 ? 'Name cannot be more than 128 characters' : undefined;
const validateNameFormat = (value) =>
  value && !/^[a-zA-Z0-9_-\s]+$/.test(value)
    ? 'Project name can only contain letters, numbers, hyphens, spaces and underscores'
    : undefined;

const ReportType: React.FC<Props> = ({ change, inUpdateReportMode, reportType, isCloning }) => {
  const { t } = useTranslation();

  const showProjectFields =
    isCloning || reportType?.value === MARKET_SURVEY;

  const projectNameValidators = showProjectFields
    ? [required, validateFirstCharacter, validateNameLength, validateNameFormat]
    : [validateFirstCharacter, validateNameLength, validateNameFormat];


  React.useEffect(() => {
    if (inUpdateReportMode)
      change('report_type', { ...availableUpdateReportTypes[0] });
  }, [inUpdateReportMode]);

  return (
    <div>
      <PageHeader>{t('navigation.reports')}</PageHeader>
      <h3 className={styles.productFieldsTitle}>
        {t('reports.createReportRequest')}
      </h3>

      <div className={styles.sectionContainer}>
        <Field
          name="report_type"
          component={FormInput}
          inputComponent={FormInputSelect}
          customLabel
          labelText={t('reports.reportTypeLabel')}
          options={
            inUpdateReportMode
              ? availableUpdateReportTypes
              : availableReportTypes
          }
          isSearchable
          hideSelectedOptions={false}
          placeholder={t('reports.reportTypePlaceholder')}
          closeMenuOnSelect={true}
          required
          value={(val) => val.value}
          onChange={(_, newValue) => {
            change('report_type', newValue);
          }}
        />
      </div>

      {showProjectFields && (
        <>
          <div className={styles.sectionContainer}>
            <Field
              name="project_name"
              variant="standard"
              component={FieldTextInput}
              fullWidth
              label={t('reports.projectName')}
              required
              validate={projectNameValidators}
            />
          </div>
          <div className={styles.sectionContainer}>
            <ClientOptionsSuperAdmin change={change} />
          </div>
          <div className={styles.sectionContainer}>
            <WorkspaceOptionsSuperAdmin change={change} />
          </div>
        </>
      )}
    </div>
  );
};

export default ReportType;
